export const uk = {
  "app.title": "survivrr.io",
  "menu.online": "Онлайн",
  "menu.offline": "Офлайн",
  "menu.play": "Грати",
  "menu.name": "Ім’я",
  "menu.ballColor": "Колір кульки",
  "menu.nameColor": "Колір імені",
  "menu.moreInfo": "Більше інформації",
  "menu.moreInfoTitle": "Більше інформації",
  "menu.moreInfoSubtitle": "Юридичні сторінки, інформація про cookies та контакти.",
  "menu.back": "Назад",
  "menu.privacySettings": "Налаштування приватності",
  "menu.cookiePolicy": "Політика cookies",
  "menu.privacyPolicy": "Політика приватності",
  "menu.termsOfService": "Умови користування",
  "menu.emailButton": "Написати e-mail",
  "menu.websiteButton": "Переглянути мій сайт",
  "menu.contactEmailLabel": "Контактний e-mail:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Переглянути мій сайт:",
  "menu.nameRequired": "Спочатку введіть ім’я.",
  "moreInfo.privacySettings.intro1": "Ви можете керувати своїми налаштуваннями приватності на цьому сайті через повідомлення про згоду від нашого рекламного провайдера, коли воно доступне.",
  "moreInfo.privacySettings.intro2": "Ви також можете будь-коли керувати cookies і локальним сховищем у налаштуваннях браузера.",
  "moreInfo.privacySettings.adsHeading": "Налаштування реклами",
  "moreInfo.privacySettings.adsParagraph": "Деякі оголошення можуть надаватися Google або іншими партнерами. Параметри персоналізованої реклами також можна змінити безпосередньо в налаштуваннях реклами Google.",
  "moreInfo.privacySettings.adsBullet1": "Відкрийте налаштування реклами Google на myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Очистьте cookies або дані сайту, якщо хочете скинути вибір згоди.",
  "moreInfo.privacySettings.adsBullet3": "Використовуйте налаштування приватності браузера, щоб блокувати або обмежувати cookies.",
  "moreInfo.privacySettings.localHeading": "Локальні налаштування",
  "moreInfo.privacySettings.localParagraph": "Ця гра зберігає базові локальні налаштування, як-от ім’я гравця, кольори, звук і мову, щоб сайт міг запам’ятати їх на вашому пристрої.",
  "moreInfo.cookiePolicy.intro1": "Цей сайт використовує cookies і подібні технології зберігання, щоб запускати гру, запам’ятовувати налаштування та підтримувати рекламу.",
  "moreInfo.cookiePolicy.intro2": "Cookies також можуть використовуватися для вимірювання, запобігання шахрайству та персоналізації реклами залежно від вашої згоди та служб, увімкнених на сайті.",
  "moreInfo.cookiePolicy.typesHeading": "Типи cookies і сховища, які ми можемо використовувати",
  "moreInfo.cookiePolicy.typeBullet1": "Необхідне сховище для роботи сайту.",
  "moreInfo.cookiePolicy.typeBullet2": "Сховище налаштувань для запам’ятовування імені, кольорів, мови та звуку.",
  "moreInfo.cookiePolicy.typeBullet3": "Рекламні або вимірювальні cookies, які використовують рекламні партнери, такі як Google, коли рекламу ввімкнено.",
  "moreInfo.cookiePolicy.manageHeading": "Як керувати cookies",
  "moreInfo.cookiePolicy.manageParagraph": "Ви можете керувати cookies через повідомлення про згоду на сайті, коли воно доступне, або через налаштування браузера. Вимкнення деяких cookies може вплинути на функції сайту або показ реклами.",
  "moreInfo.privacyPolicy.intro1": "Цей сайт є браузерною грою, якою керує Michał Kierzkowski. Ми намагаємося збирати якомога менше персональної інформації.",
  "moreInfo.privacyPolicy.intro2": "Для гри не потрібен обліковий запис. Гра може зберігати базові локальні налаштування на вашому пристрої та обробляти ігрові дані, необхідні для онлайн-матчів.",
  "moreInfo.privacyPolicy.infoHeading": "Інформація, яку ми можемо обробляти",
  "moreInfo.privacyPolicy.infoBullet1": "Обране ім’я гравця та косметичні налаштування.",
  "moreInfo.privacyPolicy.infoBullet2": "Базові дані сесії, необхідні для мультиплеєрних функцій.",
  "moreInfo.privacyPolicy.infoBullet3": "Дані пристрою, браузера або реклами, зібрані аналітичними чи рекламними партнерами, якщо такі служби ввімкнено.",
  "moreInfo.privacyPolicy.useHeading": "Як ми використовуємо інформацію",
  "moreInfo.privacyPolicy.useBullet1": "Для роботи гри та онлайн-кімнат.",
  "moreInfo.privacyPolicy.useBullet2": "Щоб запам’ятовувати налаштування на вашому пристрої.",
  "moreInfo.privacyPolicy.useBullet3": "Щоб покращувати продуктивність, безпеку та стабільність.",
  "moreInfo.privacyPolicy.useBullet4": "Щоб показувати рекламу, коли рекламу ввімкнено.",
  "moreInfo.privacyPolicy.contactHeading": "Контакт",
  "moreInfo.privacyPolicy.contactParagraph1": "Якщо у вас є питання щодо приватності, напишіть: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Сайт: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Використовуючи цей сайт, ви погоджуєтесь користуватися грою законно та чесно.",
  "moreInfo.terms.intro2": "Гра надається як є та може бути змінена, перервана або видалена в будь-який момент.",
  "moreInfo.terms.rulesHeading": "Правила",
  "moreInfo.terms.ruleBullet1": "Не зловживайте помилками, читами, автоматизацією або експлойтами.",
  "moreInfo.terms.ruleBullet2": "Не намагайтеся шкодити сервісу або іншим гравцям.",
  "moreInfo.terms.ruleBullet3": "Не використовуйте образливі, незаконні або оманливі імена чи контент.",
  "moreInfo.terms.limitationHeading": "Обмеження",
  "moreInfo.terms.limitationParagraph": "Ми не несемо відповідальності за втрати, перерви або збитки, що виникають через використання сайту, у максимальному обсязі, дозволеному законом.",
  "moreInfo.terms.changesHeading": "Зміни",
  "moreInfo.terms.changesParagraph": "Ці умови можуть оновлюватися в майбутньому. Подальше використання сайту після оновлень означає вашу згоду з оновленими умовами.",
  "status.offline": "Запуск офлайн-матчу...",
  "status.connecting": "Підключення до сервера...",
  "queue.title": "Очікування кімнати",
  "queue.menu": "Повернутися до головного меню",
  "game.pressToMove": "Натисніть будь-де, щоб рухатися",
  "game.touchToMove": "Торкніться будь-де, щоб рухатися",
  "game.leaderboard": "Таблиця лідерів",
  "game.hp": "HP",
  "game.level": "Рівень",
  "game.xp": "XP",
  "game.respawning": "Відродження...",
  "gameEnd.title": "Кінець гри",
  "gameEnd.winTitle": "Ви перемогли",
  "gameEnd.subtitle": "Матч завершено. Відродіться, щоб почати наступний раунд, або поверніться до меню.",
  "pause.title": "Меню гри",
  "pause.resume": "Продовжити",
  "pause.menu": "Повернутися до головного меню",
  "upgrade.title": "Оберіть покращення",
  "upgrade.generic.title": "Покращення",
  "upgrade.generic.description": "Покращте свій білд.",
  "upgrade.newWeaponPrefix": "Нова зброя:",
  "upgrade.stat.maxHp.title": "Макс. HP",
  "upgrade.stat.maxHp.description": "Збільшує максимальне HP.",
  "upgrade.stat.speed.title": "Швидкість руху",
  "upgrade.stat.speed.description": "Збільшує швидкість руху.",
  "upgrade.stat.generic.title": "Покращення характеристики",
  "upgrade.stat.generic.description": "Покращте свої характеристики.",
  "upgrade.weapon.projectileShot.title": "Постріл снарядом",
  "upgrade.weapon.projectileShot.description": "Додає постріли снарядами до вашого білду.",
  "upgrade.weapon.orbitingBalls.title": "Орбітальні кулі",
  "upgrade.weapon.orbitingBalls.description": "Додає орбітальні кулі до вашого білду.",
  "upgrade.weapon.damageZone.title": "Зона шкоди",
  "upgrade.weapon.damageZone.description": "Додає зону шкоди навколо персонажа.",
  "upgrade.weapon.generic.title": "Зброя",
  "upgrade.weapon.generic.description": "Додайте цю зброю до свого білду.",
  "upgrade.weaponUpgrade.frequency.title": "Частота",
  "upgrade.weaponUpgrade.frequency.description": "Атакуйте частіше.",
  "upgrade.weaponUpgrade.range.title": "Дальність",
  "upgrade.weaponUpgrade.range.description": "Збільшує дальність зброї.",
  "upgrade.weaponUpgrade.projectileCount.title": "Кількість снарядів",
  "upgrade.weaponUpgrade.projectileCount.description": "Створює більше снарядів.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Швидкість снарядів",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Робить снаряди швидшими.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Орбітальна швидкість",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Змушує орбітальні кулі обертатися швидше.",
  "upgrade.weaponUpgrade.damage.title": "Шкода",
  "upgrade.weaponUpgrade.damage.description": "Завдає більше шкоди.",
  "upgrade.weaponUpgrade.generic.title": "Покращення зброї",
  "upgrade.weaponUpgrade.generic.description": "Покращте цю зброю.",
  "defeat.title": "Поразка",
  "defeat.subtitle": "Відродіться або поверніться до меню",
  "defeat.respawn": "Відродитися",
  "defeat.menu": "Головне меню",
  "error.generic": "Щось пішло не так.",
} as const;
